<template>
	<div class="sk_eye_user_help">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">使用说明</h1>
		<h3 class="doc_main_h3">
			概述
		</h3>
		<p class="doc_main_p"> 该文档将详细说明如何在iOS平台上快速集成该SDK，并通过调用SDK接口使用SKEye图像识别服务。。</p>
		<h3 class="doc_main_h3">
			系统需求
		</h3>
		<p class="doc_main_p">iOS8.0及以上版本系统</p>
		<h3 class="doc_main_h3">
			使用步骤
		</h3>
		<p class="doc_main_p">
			（1）在Xcode新建工程。
		</p>
		<p class="doc_main_p">
			（2）解压下载的SDK压缩包，将Libs文件夹拖拽到工程导航视图中。
			<img src="../../../static/images/objectRecognition/ios/1.png" class="ios_1_png">
		</p>
		<p class="doc_main_p">
			（3）下一步，如图勾选后，点击finish。
			<img src="../../../static/images/objectRecognition/ios/2.png" class="ios_1_png">
		</p>
		<p class="doc_main_p">
			（4）在AppDelegate.m里面导入头文件eyeTool.h，在-(BOOL)application:
				(UIApplication *)application didFinishLaunchingWithOptions:
				(NSDictionary *)launchOptions方法里初始化SDK，如图：
			<img src="../../../static/images/objectRecognition/ios/3.png" class="ios_1_png">
		</p>
		<p class="doc_main_p">
			（5）在需要使用识别接口的文件中，导入eyeTool.h头文件，调用sdk提供的类方法即可。
		</p>
		<h3 class="doc_main_h3">
			Demo说明
		</h3>
		<p class="doc_main_p">
			案例展示如何调用SKEyeSDK接口，图像识别结果会在运行界面上展示，并以log形式打印。
		</p>
		<h3 class="doc_main_h3">
			关键参数说明
		</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">apiKey：NSString类型，指当前APP所申请的SKEye的API_KEY
apiSecret：NSString类型，指当前APP所申请的SKEye的API_SECRET
serviceName：NSString类型，指SKEye识别的服务名称
SERVICE_NAME_OBJECT：NSString类型，指常见物品识别服务名称
SERVICE_NAME_FRUITS：NSString类型，指水果识别服务名称
imageId：NSString类型，图片id（方便确认请求顺序和返回顺序是否一致）
</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['物体识别','SKEye-iOS','使用说明'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../less/index.less';
	.sk_eye_user_help{
		.ios_1_png{
			display: block;
			width: 500px;
			margin:20px auto;
		}
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skeyeios/SKEyeUserHelp.vue